// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"8461788b","358":"d1c47e9a","563":"dc1adc72","729":"0dcab145","919":"37c711d7"}[chunkId] + ".chunk.js";
};